import * as _ from 'lodash';

import {
  AthenaTableGQLType,
  AthenaTablePropertyTypeGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

const stringIcon = 'font-case';
const numberIcon = 'hashtag';
export const athenaDataTypeToIcon: Record<
  AthenaTablePropertyTypeGQLType,
  string
> = {
  boolean: 'check',
  tinyint: numberIcon,
  smallint: numberIcon,
  int: numberIcon,
  integer: numberIcon,
  bigint: numberIcon,
  double: numberIcon,
  float: numberIcon,
  decimal: numberIcon,
  char: 'font-case',
  varchar: stringIcon,
  string: stringIcon,
  binary: 'binary',
  date: 'calendar-days',
  timestamp: 'clock',
  array: 'brackets-square',
  map: 'brackets-curly',
  struct: 'brackets-curly',
};

export const filterAthenaTablesForCreditFacilities = ({
  athenaTables,
  creditFacilitySlugs,
}: {
  athenaTables: AthenaTableGQLType[];
  creditFacilitySlugs: string[];
}) => {
  return _.filter(athenaTables, (athenaTable) => {
    const athenaTableNameParts = athenaTable.tableName.split('_');
    const athenaTableNameSuffix =
      athenaTableNameParts[athenaTableNameParts.length - 1];

    const lowerCaseCreditFacilitySlugs = creditFacilitySlugs.map((slug) =>
      _.toLower(slug),
    );

    return lowerCaseCreditFacilitySlugs.includes(
      _.toLower(athenaTableNameSuffix),
    );
  });
};

const athenaTablePrefixesRelevantToAthenaSqlGeneration = [
  'internal_repayment_tapes_latest',
  'receivable_response_tapes_latest',
  'limited_partner_tapes_latest',
  'limited_partner_tapes',
  'cdq_acknowledgements',
];
// for our current AthenaSqlGeneration use-case,
// it is likely that the user only needs to query certain tables.
// we will filter out the noise to have a better user experience when selecting tables
export const filterAthenaTablesRelevantToSqlGeneration = ({
  athenaTables,
}: {
  athenaTables: AthenaTableGQLType[];
}) => {
  return athenaTables.filter((athenaTable) =>
    athenaTablePrefixesRelevantToAthenaSqlGeneration.some((prefix) =>
      athenaTable.tableName.startsWith(prefix),
    ),
  );
};
